import React, {useEffect, useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {Navigate} from "react-router-dom";
import {RootState} from "../../../reducers";
import LoadingContainer from "../../components/Common/LoadingContainer";
import {useSessionService} from "../../services/Session/sessionService";
import {getSession} from "../../services/Session/reducer";
import AppConfig from "../../services/AppConfig";
import {usePrefix} from "../../services/Prefix";


type Props = ReturnType<typeof mapStateToProps> & DispatchProp;

function PickUpOrderTypePage(props: Props) {
    const [loading, setLoading] = useState(true);
    const [redirect, setRedirect] = useState(false);
    const orderType = "PICK_UP";
    const sessionService = useSessionService();
    const prefix = usePrefix();


    const init = async () => {
        let sessionData = {
            ...props.session,
            order_type: orderType
        }
        try {
            await sessionService.update(sessionData);
            setRedirect(true);
        } catch (error) {
        }
    }
    useEffect(() => {

        init();
    }, []);

    if (redirect) {
        return (
            <Navigate to={AppConfig.getLinkWithPrefix("/", prefix)}/>
        )
    }
    if (loading) {
        return (
            <LoadingContainer/>
        );
    }
    return (
        <Navigate to={AppConfig.getLinkWithPrefix("/", prefix)}/>
    )
}

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session)
})

const connector = connect(mapStateToProps);

export default connector(PickUpOrderTypePage);
